import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import CameraIcon from '@quintoandar/cozy-icons/Camera';
import Box from '@quintoandar/cozy-core/Box';
import FeedbackBlock from '@quintoandar/cozy-core/FeedbackBlock';
import { LoadingPage } from 'components/LoadingPage';
import RetryFeedback from 'components/RetryFeedback';

import Timeline from 'components/Timeline';
import { fetchNotStartedPhotoSessionsAction } from './actions';
import {
  makeSelectNotStartedPhotoSessions,
  makeSelectHasFetchedNotStartedPhotoSessions,
  makeSelectShowNotStartedListError,
} from './selectors';
import { buildPhotoSessionItems } from './photoSessionItemsBuilder';
import messages from './messages';

export const NotStartedPhotoSessions = ({
  photoSessions,
  fetchNotStartedPhotoSessions,
  intl,
  hasFetchedNotStartedPhotoSessions,
  showListError,
}) => {
  /* istanbul ignore next */
  useEffect(() => {
    fetchNotStartedPhotoSessions();
  }, []);
  if (!hasFetchedNotStartedPhotoSessions) {
    return <LoadingPage />;
  }

  if (photoSessions.length === 0) {
    if (showListError) {
      return (
        <RetryFeedback
          title={messages.notStartedPhotoSessionsError}
          subtitle={messages.listErrorSubtitle}
          onRetry={fetchNotStartedPhotoSessions}
        />
      );
    }

    return (
      <Box mt={4}>
        <FeedbackBlock
          kind="empty-state"
          icon={CameraIcon}
          subtitle={messages.notStartedPhotoSessionsEmptyStateSubTitle}
          title={messages.notStartedPhotoSessionsEmptyStateTitle}
          showButton={false}
        />
      </Box>
    );
  }

  const notStartedPhotoSessions = buildPhotoSessionItems({ photoSessions, intl });

  return <Timeline scheduledItems={notStartedPhotoSessions} />;
};

const mapStateToProps = createStructuredSelector({
  photoSessions: makeSelectNotStartedPhotoSessions(),
  hasFetchedNotStartedPhotoSessions: makeSelectHasFetchedNotStartedPhotoSessions(),
  showListError: makeSelectShowNotStartedListError(),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchNotStartedPhotoSessions: () => dispatch(fetchNotStartedPhotoSessionsAction()),
});

NotStartedPhotoSessions.propTypes = {
  photoSessions: PropTypes.array,
  fetchNotStartedPhotoSessions: PropTypes.func.isRequired,
  intl: PropTypes.object,
  hasFetchedNotStartedPhotoSessions: PropTypes.bool,
  showListError: PropTypes.bool,
};

NotStartedPhotoSessions.defaultProps = {
  photoSessions: [],
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(NotStartedPhotoSessions);
